import type { SupportSource } from '@/constants/dataLayer';
import type { SupportCategoryId } from '@/constants/support';

import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';

type SupportStoreType = {
    isOpen: boolean;
    source: SupportSource | null;
    categoryId: SupportCategoryId | null;
    openSupport: (source: SupportSource, categoryId?: SupportCategoryId) => void;
    closeSupport: () => void;
};

export const useSupportStore = create<SupportStoreType>()(
    immer((set) => ({
        isOpen: false,
        source: null,
        categoryId: null,
        openSupport: (source, categoryId) =>
            set((state) => {
                state.isOpen = true;
                state.source = source;
                state.categoryId = categoryId ?? null;
            }),
        closeSupport: () =>
            set((state) => {
                state.isOpen = false;
            })
    }))
);
